import React, { FC, useCallback, useMemo } from 'react';
import ImportGridModal from '../ow_import_grid/ImportGridModal';
import {
	getReceivedEquipmentImportHeader,
	PARTIAL_UPLOAD_CRUD_FIELD,
	getImportRecordForReceivedEquipmentExport,
} from '../stock_locations_detail_details_page/stock_location_constants';
import { CSV_EXPORT_DEFAULTS } from '../../utils/DataConstants';
import { ExportToCsv } from 'export-to-csv';
import { requiredWithValueRecordHook } from '../ow_import_grid/import_record_hooks';

const PartialEPSLUpload: FC<any> = ({
	hideUploadPopup,
	allEquipmentTypesNames,
	allVendorNames,
	onDataUpload,
	recordHook,
}): React.ReactElement => {
	const IMPORT_HEADER_WITH_CRUD_ACTION = useMemo(
		() => [
			PARTIAL_UPLOAD_CRUD_FIELD,
			...getReceivedEquipmentImportHeader(allEquipmentTypesNames, allVendorNames),
		],
		[allEquipmentTypesNames, allVendorNames]
	);

	const onDownloadSample = useCallback(() => {
		const csvTitle = `Partial_Equipment_Upload_Sample`;
		const csvExporter = new ExportToCsv({
			...CSV_EXPORT_DEFAULTS,
			filename: csvTitle,
			title: csvTitle,
			headers: IMPORT_HEADER_WITH_CRUD_ACTION.map((_) => _.label),
		});

		const data = [
			{
				crudAction: 'create',
				...getImportRecordForReceivedEquipmentExport({}),
			},
			{
				crudAction: 'update',
				...getImportRecordForReceivedEquipmentExport({ id: 1234 }),
			},
			{
				crudAction: 'delete',
				...getImportRecordForReceivedEquipmentExport({ id: 4567 }),
			},
		];
		csvExporter.generateCsv(data);
	}, [IMPORT_HEADER_WITH_CRUD_ACTION]);

	const updatedRecordHook = (record) => {
		const updatedRecord = recordHook ? recordHook(record) : record;
		return requiredWithValueRecordHook(['id'], 'crudAction', ['update', 'delete'])(updatedRecord);
	};

	return (
		<ImportGridModal
			visible
			title="Partial Equipment Upload"
			sampleModalText="Do you want to download Sample?"
			sampleButtonText="Download Sample"
			recordHook={updatedRecordHook}
			onCancel={hideUploadPopup}
			onDownloadSample={onDownloadSample}
			fields={IMPORT_HEADER_WITH_CRUD_ACTION}
			onDataLoad={onDataUpload}
			onComplete={hideUploadPopup}
		/>
	);
};

export default PartialEPSLUpload;
